function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import Component from '@glimmer/component';
import { guidFor } from '@ember/object/internals';
// import { assert } from '@ember/debug';

// We have a base class to keep consistency between the inputs
export class BaseUIComponent extends Component {
  constructor(owner, args) {
    super(owner, args);
    // assert('@label is required', args.label !== undefined);
    _defineProperty(this, "guid", guidFor(this));
  }
  get changeEvent() {
    return this.args.changeEvent ?? 'change';
  }

  // eslint-disable-next-line no-unused-vars
}